import { AfterViewInit, Component, Input, OnChanges, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { applicationPaths, localStorageKeys } from '../../../Models/configurations';
import { AppsettingService } from '../../../Services/appsetting.service';
import { progressStepNames } from './../../../Models/progress-bar-step';
import { SecureStorageService } from './../../../Services/secure-storage.service';

@Component({
  selector: 'app-step-progress-bar',
  templateUrl: './step-progress-bar.component.html',
  //styleUrls: ['./step-progress-bar.component.css']
})
export class StepProgressBarComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() wizardSteps: any;
  @Input() stepName: string;
  @Input() stepCompleted: boolean;
  data: any[];
  urlName: string;
  breadCrumb: any;
  stepLength:number;
  headerClass:string;

  isthreeIcons: boolean = false;
  isFourIcons: boolean = false;

  constructor(
    private readonly secureStorageService: SecureStorageService,
    private readonly appsettingService: AppsettingService,
    private router: Router,
  ) {
    if (this.secureStorageService.getKeyData(localStorageKeys.stepStatus) === undefined) {
      this.data = this.appsettingService.fetchSiteElements();
    }
  }


  public nagivateToStep(stepName: string): void {
    if (stepName === progressStepNames.stepName1
      && this.secureStorageService.getKeyData(localStorageKeys.ownerDetails) !== undefined) {
      this.urlName = '/' + applicationPaths.second;
      this.router.navigateByUrl(this.urlName);
    } else if (stepName === progressStepNames.stepName2 &&
      this.secureStorageService.getKeyData(localStorageKeys.privacyConsent) !== undefined) {
      this.urlName = '/' + applicationPaths.third;
      this.router.navigateByUrl(this.urlName);
    } else if (stepName === progressStepNames.stepName3 &&
      this.secureStorageService.getKeyData(localStorageKeys.additionalDetails) !== undefined) {
      this.urlName = '/' + applicationPaths.fourth;
      this.router.navigateByUrl(this.urlName);
    } else if (stepName === progressStepNames.stepName4
      && this.secureStorageService.getKeyData(localStorageKeys.serviceDetails) !== undefined) {
      this.urlName = '/' + applicationPaths.five;
      this.router.navigateByUrl(this.urlName);
    }
  }

  ngOnInit(): void {
    this.stepLength=this.wizardSteps.length;
    if(this.stepLength===3)
    {
      this.headerClass='headermenu'
    }
  }

  ngOnChanges(): void {
    // This is intentional
  }
  ngAfterViewInit(): void {
    // This is intentional
  }
}
